import CreateView from "../../../custom/CreateView";
import React, {useCallback, useState} from "react";
import {InputType} from "../../../../common/FormRenderer";
import { useUser } from "../../../../Auth";
import { useCreateLogMutation, useGetUserListQuery, RoleIdEnum } from "../../../../generated/graphql";
import { find, filter } from "lodash";
import NotificationPopup from "../../../../common/NotificationPopup";
import { hasRole } from "../../../../common/Util";

export default ({template, adapter}: {template: any; adapter: any}) => {
  const [selectedAssignee, setSelectedAssignee] = useState<any>();
  const user = useUser();
  const [createLog] = useCreateLogMutation();
  const [updateTemplateAssignee] = adapter.useUpdateTemplateAssigneeMutation();
  const { data: usersData } = useGetUserListQuery({ fetchPolicy: "cache-and-network" });

  // 篩選只顯示有 Admin, Pm, PmManager 角色的用戶
  const allowedRoles = [RoleIdEnum.Admin, RoleIdEnum.Pm, RoleIdEnum.PmManager];
  const filteredUsers = filter(usersData?.users ?? [], (u: any) => 
    hasRole(u, allowedRoles)
  );

  const assigneeColumns = [
    {
      name: "assignee",
      label: "負責人",
      type: InputType.autoComplete,
      options: filteredUsers.map((u:any) => ({
        value: u.id,
        label: u.name,
      })),
      onChange: (id: string) => {
        const u = find(filteredUsers, (x:any) => x.id == id);
        setSelectedAssignee(u || null);
      },
    },
  ];

  const onSubmit = useCallback(
    async (_values: any, { resetForm }: any, setOpen: (b: boolean) => void) => {
      if (!selectedAssignee) {
        NotificationPopup.error("請選擇負責人");
        return;
      }

      try {
        // 1. 呼叫轉移負責人 mutation
        await updateTemplateAssignee({
          variables: {
            templateId: parseInt(template.id),
            assigneeId: parseInt(selectedAssignee.id),
          },
          refetchQueries: [adapter.refetchTemplatesQueryName],
        });

        // 2. 寫入 log
        if (user) {
          await createLog({
            variables: {
              log: {
                entityId: String(template.id),
                userId: String(user.id),
                queryAction: "轉移負責人",
                queryEntity: "template",
                queryMessage: `模板名稱: ${template.name}, 新負責人: ${selectedAssignee.name}`,
              },
            },
          });
        }

        NotificationPopup.success("轉移負責人成功");
        setOpen(false);
        resetForm();
      } catch (error: any) {
        NotificationPopup.error(`轉移負責人失敗: ${error.message}`);
        console.error('Transfer assignee error:', error);
      }
    },
    [selectedAssignee, template, user, createLog, updateTemplateAssignee, adapter]
  );

  return (
    <CreateView
      title="轉移負責人"
      columns={assigneeColumns}
      onSubmit={onSubmit}
      submitTitle="確定"
      queryEntity={adapter.generateQueryEntity}
    />
  );
};
